import type { ResolvedCredential } from './EntityResolverContext';

export type CredentialEntitySource = {
  id: string;
  username?: string | null;
  role?: string | null;
  ssoProvider?: string | null;
};

export function buildCredentialDisplayName({
  username,
  role,
}: {
  username?: string | null;
  role?: string | null;
}): string {
  const trimmedUsername = username?.trim();
  const trimmedRole = role?.trim();

  if (trimmedUsername) {
    return trimmedRole
      ? `${trimmedUsername} (${trimmedRole})`
      : trimmedUsername;
  }

  return trimmedRole ?? '';
}

export function buildResolvedCredentialsMap(
  credentials: CredentialEntitySource[],
): Record<string, ResolvedCredential> {
  return credentials.reduce<Record<string, ResolvedCredential>>(
    (resolvedCredentials, credential) => {
      resolvedCredentials[credential.id] = {
        id: credential.id,
        name: buildCredentialDisplayName({
          username: credential.username,
          role: credential.role,
        }),
        type: credential.ssoProvider ?? 'credentials',
        role: credential.role ?? undefined,
        username: credential.username ?? undefined,
      };
      return resolvedCredentials;
    },
    {},
  );
}
